import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Radio, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/CidadeActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class CidadeList extends XAPPComponent {

    state = {
        selected: []
    };

    handleChangeRadio = (name, item) => {
        var AState = this.state.selected;
        var AExists = false;
        if (this.isSelected(item.id))
            AExists = true;

        if (!AExists) {
            var obj = item;
            obj["id"] = item.id;
            obj["label"] = item.cidade;
            if (!this.props.multiSelect)
                AState = [];
            AState.push(obj);
            this.setState(_.set({ ...this.state }, name, AState));
            this.props.onChange(AState);
        }
    };

    isSelected = (id) => {
        var AState = this.state.selected;
        var AExists = false;
        AState.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AColumns, _AisLookup) => {
        if (_AisLookup !== true) {
            _AColumns.splice(0, 1);
        }
        return _AColumns;
    };

    render() {
        const { Cidade, isLookup, classes } = this.props;
        const { selected } = this.state;
        const Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && (
                            <Radio
                                checked={selected?.length > 0 && this.isSelected(row.original.id)}
                                onClick={event => event.stopPropagation()}
                                onChange={event => this.handleChangeRadio("selected", row.original)}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: "Nome",
                accessor: "cidade",
                className: "ml-8"
            },
            {
                Header: "UF",
                accessor: "uf",
                width: 80,
                className: ""
            },
            {
                Header: "Pais",
                accessor: "pais",
                width: 256,
                className: ""
            }
        ];

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>

                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    data={Cidade ? Cidade : []}
                    columns={this.getColumns(Columns, isLookup)}
                    defaultPageSize={10}
                    noDataText="Não existem registros cadastrados!"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {
                                if (rowInfo) {
                                    this.handleChangeRadio("selected", rowInfo.original);
                                }
                            }
                        };
                    }}
                />

            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list
    }, dispatch);
}

function mapStateToProps({ CidadeApp }) {
    return {
        Cidade: CidadeApp.data,
        selectedId: CidadeApp.selectedId,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CidadeList)));
